<template>
    <div class=" tables vacancies theme-card" ref="tableContainer">
        <div class="widget-loading-indicator" v-if="loading">
            <LoadingIndicator v-if="loading" message="Loading Vacancies"/>
        </div>
        <div v-if="!loading" class="table-header">
                <div class="table-title"><span>Vacancies</span> <span v-if="vacanciesMeta != null" title="Total Vacancies" class="total">{{ vacanciesMeta.totalCount }}</span></div>
                <div v-if="vacanciesMeta != null" class="page-count" :title="'page ' + currentPage + ' of ' + vacanciesMeta.totalPages">{{currentPage}}/{{ vacanciesMeta.totalPages > 0 ? vacanciesMeta.totalPages : 1 }}</div>
            </div>
        <div class="table-content"> 
            
            <div v-if="!loading" class="table-tools" style="display:flex;justify-content: space-between;align-items:center;">
                <div class="table-actions">
                    <button type="button" class="search-btn" :disabled="searchBtnClicked" @click="loadInitPageForSearch">
                        <SearchIcon/>
                    </button>
                    <input type="text" v-model="searchBody.search" class="search-query" placeholder="Search Vacancies" @keyup.enter="loadInitPageForSearch">
                    <button type="button" class="search-btn" :disabled="cancelBtnClicked" style="background:var(--background)!important;color:var(--page-header);margin-left:0.5rem;" v-if="isSearch" @click="loadInitPage">
                        <CloseIcon/>
                    </button>
                </div>  
                    <button class="delete-all" @click="showDeleteAllOptions" :disabled="deleteAllBtnClicked">
                        <span style="font-size:0.9rem;">{{ deleteAllBtnClicked == true ? 'Deleting...' : 'Delete All' }}</span></button>
            </div>
            
            <table v-if="!loading" id="myTable" class="display" style="margin-top:1rem;">
                <thead>
                    <tr class="app-table-head">
                        <th>Title</th>
                        <th>Location</th>
                        <th>Job Type</th>
                        <th>Closing Date</th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- item -->
                     <tr v-for="vacancy in vacancies" :key="vacancy.jobId">
                        <td :title="vacancy.jobTitle"><div class="row-context">{{ vacancy.jobTitle }}</div></td>
                        <td :title="vacancy.location"><div class="row-context">{{ vacancy.location }}</div></td> 
                        <td :title="vacancy.jobType"><div class="row-context">{{ vacancy.jobType || '--' }}</div></td> 
                        <td title="Closing Date">{{ vacancy.closingDate }}</td> 
                        <td class="row-actions">
                            <button title="List of Applicants" @click="viewApplicants(vacancy)" type="button" class="btn badge-btn btn-sm btn-primary">
                            <span class="badge-label">Applicants</span> <span class="badge">{{ vacancy.totalApplicants }}</span>
                            </button>
                            <button title="List of Shortlisted" @click="viewShortlist(vacancy)" type="button" style="background-color: var(--icon-blue);color:white;" class="btn badge-btn btn-sm btn-default">
                           <span class="badge-label">Shortlist</span> <span class="badge">{{ vacancy.totalShortList }}</span>
                            </button>
                        </td> 
                        <td>
                            <div class="icon-buttons">
                                <button title="Change Visibility" style="color:var(--page-header);opacity:0.4;" class="icon-button" v-if="vacancy.isVisible" @click="changeVisibility(vacancy)" :disabled="eyeButtonDisabled">
                                    <InvisibleIcon class="icon-button-icon"/>
                                </button>
                                <button title="Change Visibility" style="color:var(--page-header);" class="icon-button" @click="changeVisibility(vacancy)" :disabled="eyeButtonDisabled" v-else>
                                    <InvisibleIcon class="icon-button-icon"/>
                                </button>
                                <button title="Edit" @click="setForEdit(vacancy)" style="color:var(--icon-blue);" class="icon-button">
                                    <EditIcon class="icon-button-icon"/>
                                </button>
                                <button title="Delete" @click="setForDelete(vacancy)" style="color:var(--red);" class="icon-button">
                                    <TrashIcon class="icon-button-icon"/>
                                </button>
                            </div>
                        </td>
                    </tr>

                     <!--  -->

                </tbody>
            </table>
                <div v-if="!loading" class="custom-pagination" style="margin-top:2rem;">
                    <button class="btn btn-default btn-sm pager-btn" :disabled="currentPage === 1" @click="prevPage">Prev</button>
                    <button class="btn btn-default btn-sm pager-btn" :disabled="vacancies.length < 20" @click="nextPage">Next</button>
                </div>
        </div>
    </div>
    <CustomConfirmationMessageModal :title="modal.caption"
            ref="empVacancyModal"
           :body="modal.message"
           :button-label="modalButtonLabel"
           :close-modal="() => closeModal()"
           :modal-id="modalId"/>
    <WarningOptionsModal
            ref="delVacModal"
            :body="this.delModal.body"
            :title="this.delModal.title"
            :close-modal="this.delModal.closeModal"
            :yes-selected="this.delModal.yesSelected"
            :yes-button-label="this.delModal.yesButtonLabel"
            :no-button-label="this.delModal.noButtonLabel"
            :modal-id="this.delModal.modalId"
            loading-button-label="Deleting Vacancy..."
            />
    <WarningOptionsModal
            ref="delAllVacModal"
            :body="this.delAllModal.body"
            :title="this.delAllModal.title"
            :close-modal="this.closeDelAllModal"
            :yes-selected="this.deleteAll"
            :yes-button-label="this.delAllModal.yesButtonLabel"
            :no-button-label="this.delAllModal.noButtonLabel"
            :modal-id="this.delAllModal.modalId"
            loading-button-label="Deleting All Vacancies..."
            />
    <EditVacancyModal
        ref="editVacModal"
        :modal-id="this.editModal.modalId"
        :close-modal-on-success="closeEditModalOnSuccess"
        :vacancy="this.editModal.vacancy"/>
    <ToastMessage 
        ref="vacancyToast"
        :message="toast.message"
        :success="toast.success"/>
        

</template>
<script>
import DataTable from 'datatables.net-dt';
import store from '@/store';
import EditVacancyModal from '@/components/modals/EditVacancyModal.vue';
import WarningOptionsModal from '@/components/modals/WarningOptionsModal.vue';
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import CustomConfirmationMessageModal from '@/components/modals/CustomConfirmationMessageModal.vue';
import VisibleIcon from '@/components/IconComponents/VisibleIcon.vue';
import InvisibleIcon from '@/components/IconComponents/InvisibleIcon.vue';
import EditIcon from '@/components/IconComponents/EditIcon.vue';
import TrashIcon from '@/components/IconComponents/TrashIcon.vue';
import SearchIcon from '@/components/IconComponents/SearchIcon.vue';
import CloseIcon from '@/components/IconComponents/CloseIcon.vue';
import ToastMessage from '@/components/modals/ToastMessage.vue';
export default {
    data() {
        return {
            searchQuery: '',
            table: null,
            currentPage: 1,
            totalPages: 0,
            pagerPages: [],
            pageSize: 10,
            totalRecords: 0,

            loading: true,
            modal:{
                caption:"",
                message:""
            },
            modalButtonLabel:'Close',
            modalId:"empVac",
            isSearch:false,
            searchBody:{
                search:""
            },
            delModal:{
                title:"",
                body:"",
                modalId:"delVac",
                yesButtonLabel:"Delete Vacancy",
                noButtonLabel:"Cancel",
                closeModal: null,
                yesSelected: null
            },
             delAllModal:{
                title:"Delete All Vacancies",
                body:"<p><b>WARNING!</b><br/> You are about to permanently delete all the vacancies you have ever published. Note that this is action is irreversible.<p/><p>Are you sure want to permanently delete all your vacancies?</p>",
                modalId:"delAllVac",
                yesButtonLabel:"Delete All",
                noButtonLabel:"Cancel"
            },
            editModal:{
                modalId:"editVac",
                vacancy: null
            },
            eyeButtonDisabled: false,
            searchBtnClicked: false,
            cancelBtnClicked: false,
            deleteAllBtnClicked: false,
            toast:{
                message:"",
                success:true
            }

        };
    },
    components:{
        LoadingIndicator,
        CustomConfirmationMessageModal,
        WarningOptionsModal,
        EditVacancyModal,
        VisibleIcon,
        InvisibleIcon,
        EditIcon,
        TrashIcon,
        SearchIcon,
        CloseIcon,
        ToastMessage
    },
    computed:{
        vacancies(){
            return this.$store.getters["employerVacancies/getVacancies"] || [];       
        },
        vacanciesMeta(){
            return this.$store.getters["employerVacancies/getVacanciesMetaData"] || null;
        }
    },
    async mounted(){
        this.loadInitPage(1);
        this.table = new DataTable('#myTable', {
                       dom: 'rt',
                       scrollY: 300,
                       scrollCollapse: false,
                       ordering: false,
                       paging: false,
                       searching: false,
            });
    },
    methods: {
        showDeleteAllOptions(){
            this.showDelAllModal();
        },
        async deleteAll(){
            try{
            this.closeDelAllModal();
            this.deleteAllBtnClicked = true;
            await this.$store.dispatch("employerVacancies/deleteAllVacanciesAsync");
            this.deleteAllBtnClicked = false;
            }catch(e){
                this.deleteAllBtnClicked = false;
                this.modal.caption = e.reason;
                this.modal.message = e.message;
                this.showModal();
            }
        },
        async loadInitPage(){ //load the first page upon page visit
            try{
            this.cancelBtnClicked = true; //for when a user cancels search. Just keep it here
            this.currentPage = 1;
            this.isSearch = false;
            this.searchBody.search = "";
            await this.$store.dispatch("employerVacancies/getVacanciesAsync", this.currentPage);
            this.loading = false;
            this.cancelBtnClicked = false;
            }catch(e){
                this.loading = false;
                this.cancelBtnClicked = false;
                // this.modal.caption = e.reason;
                // this.modal.message = e.message;
                // this.showModal();

                let message = e.message == 'Failed to fetch' ? 'Unable to get vacancies. Check your internet connection or refresh the page.' : e.message;
                this.toast = {
                    message: message,
                    success: false
                }
                this.showToastMessage();
            }
        },
        async loadInitPageForSearch(){ //load the first page upon search
            try{
            this.searchBtnClicked = true;
            this.currentPage = 1;
            await this.$store.dispatch("employerVacancies/searchVacanciesAsync", {
                data: this.searchBody,
                page: this.currentPage
            });
            this.isSearch = true;
            this.loading = false;
            this.searchBtnClicked = false;
            }catch(e){
                this.loading = false;
                this.searchBtnClicked = false;
                // this.modal.caption = e.reason;
                // this.modal.message = e.message;
                // this.showModal();

                let message = e.message == 'Failed to fetch' ? 'Unable to get vacancies search results. Check your internet connection or try again.' : e.message;
                this.toast = {
                    message: message,
                    success: false
                }
                this.showToastMessage();
            }
        },
         closeModal(){
        if (this.$refs.empVacancyModal && typeof this.$refs.empVacancyModal.hide === 'function') {
        this.$refs.empVacancyModal.hide();
        }
        },
        showModal(){
            if(this.$refs.empVacancyModal != null){
                this.$refs.empVacancyModal.show();
            }
        },
        async goToPage(page) {
            try{
                if(!this.isSearch){   
                await this.$store.dispatch("employerVacancies/getVacanciesAsync", page);
                }else{
                    await this.$store.dispatch("employerVacancies/searchVacanciesAsync", {
                    data: this.searchBody,
                    page: page
                });
                }
                this.$nextTick(() => {
                        //this.$refs.tableContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        window.scrollTo({top: 0,behavior: 'smooth'});
                    });
            }catch(e){
                let message = e.message == 'Failed to fetch' ? 'Unable to navigate to page. Check your internet connection.' : e.message;
                this.toast = {
                    message: message,
                    success: false
                }
                this.showToastMessage();
            }
        },
        async prevPage() {
            window.scrollTo({top: 0,behavior: 'smooth'});
            if(this.currentPage > 1){

                await this.goToPage(this.currentPage -= 1);
            }
        },
        async nextPage() {
            window.scrollTo({top: 0,behavior: 'smooth'});
            await this.goToPage(this.currentPage += 1);
        },
        async changeVisibility(vacancy){
            try{
            this.eyeButtonDisabled = true;
            await this.$store.dispatch("employerVacancies/changeVisibilityAsync", vacancy.jobId);
            this.eyeButtonDisabled = false;
            let message = vacancy.isVisible == true ? `${vacancy.jobTitle} is now visible to the public` : `${vacancy.jobTitle} has been hidden from the public`
            this.toast = {
                message: message,
                success: true
            }
            this.showToastMessage();
            }catch(e){
                this.eyeButtonDisabled = false;

                let message = vacancy.isVisible == true ? `Failed to make ${vacancy.jobTitle} hidden from the public. Please check your connection or try again later` : `Failed to make ${vacancy.jobTitle} visible to the public. Please check your connection or try again later`
                this.toast = {
                    message: message,
                    success: false
                }
                this.showToastMessage();
                
            }
        },

        closeEditModal(){
        if (this.$refs.editVacModal && typeof this.$refs.editVacModal.hide === 'function') {
            this.$refs.editVacModal.hide();
        }
        },

        closeEditModalOnSuccess(jobTitle){
            if (this.$refs.editVacModal && typeof this.$refs.editVacModal.hide === 'function') {
                this.$refs.editVacModal.hide();
                this.toast = {
                    message : `${jobTitle} has been updated`,
                    success: true
                }
                this.showToastMessage();
            }
        },

        showEditModal(){
            this.$refs.editVacModal.show();
        },

         closeDelModal(){
        if (this.$refs.delVacModal && typeof this.$refs.delVacModal.hide === 'function') {
        this.$refs.delVacModal.hide();
        }
        },
        showDelModal(){
            this.$refs.delVacModal.show();
        },

         closeDelAllModal(){
        if (this.$refs.delAllVacModal && typeof this.$refs.delAllVacModal.hide === 'function') {
        this.$refs.delAllVacModal.hide();
        }
        },
        showDelAllModal(){
            this.$refs.delAllVacModal.show();
        },
        setForDelete(job){
            this.delModal.title = "Delete Vacancy",
            this.delModal.body = `Are you sure you want to permanently delete the following vacancy?<br/>Please note that any and all applicants will not be made available for your review.<br/><br/>` +
            `<span style="font-weight:bold;">Job Title:</span> <span>${job.jobTitle}</span><br/>` + 
            `<span style="font-weight:bold;">Location:</span> ${job.location}<br/>`+ 
            `<span style="font-weight:bold;">Closing Date:</span> ${job.closingDate}<br/>`
            this.delModal.yesSelected = async() => await this.deleteVacancy(job);
            this.delModal.closeModal = () => this.closeDelModal();
            this.showDelModal();
        },
         setForEdit(job){
            this.editModal.closeModal = () => this.closeEditModal();
            this.editModal.vacancy = job;
            this.showEditModal();
        },

        async deleteVacancy(job){
            try{
            this.$refs.delVacModal.startLoading();
            await this.$store.dispatch("employerVacancies/deleteVacancyAsync", job.jobId);
            this.$refs.delVacModal.stopLoading();
            this.closeDelModal();
            this.toast = {
                message: `${job.jobTitle} has been deleted`,
                success: true
            }
            this.showToastMessage();
            }catch(e){
                this.$refs.delVacModal.stopLoading();
                this.closeDelModal();
                // this.modal.caption = e.reason;
                // this.modal.message = e.message;
                this.toast = {
                message: `Failed to delete ${job.jobTitle}. Please check your connection or try again later`,
                success: false
            }
            this.showToastMessage();
                
            }
        },
        viewApplicants(vacancy){
            this.$store.dispatch('jobApplicants/updateSelectedVacancy', vacancy);
            sessionStorage.setItem('vacancyInfo', JSON.stringify(vacancy));
            this.$router.push({name: 'applicants-list'});
        },
        viewShortlist(vacancy){
            this.$store.dispatch('jobApplicants/updateSelectedVacancy', vacancy);
            sessionStorage.setItem('vacancyInfo', JSON.stringify(vacancy));
            this.$router.push({name: 'shortlisted-list'});
        },
        showToastMessage(){
             this.$nextTick(() => {
                    if(this.$refs.vacancyToast != null){
                        this.$refs.vacancyToast.show();
                    }
                });
        },
        


       
    }
}
</script>
<style scoped>
    .display{
        font-family: var(--body-font)!important;
    }

    th{
        font-family: var(--body-font-bold)!important;
        font-weight: normal!important;
    }

    .theme-card{
        border-radius:18px;
        background-color: var(--intro-background);
    }

    .search-query{
    padding:0.5rem 0.8rem;
     width:25rem;
    margin-bottom:0.4rem;
}
    
    .icon-button-icon{
        height:1rem;
    }
    .icon-buttons{
        display: flex;
        justify-content: center;
    }
    .icon-button{
        border:0px;
        background: transparent;
    }

    .badge-label{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .badge-btn{
        font-size:0.8rem;
        border-radius: 100px;
        border:0px;
    }

    .badge-btn:first-child{
        margin-right:0.4rem;
        background-color: rgb(20, 138, 20);
    }

    .badge-btn:last-child{
        background: var(--blue)
    }
    .badge{
        color:black;
        background: white;
        margin-left:0.3rem;
        margin-top:0.2rem;
        border-radius: 100px;
    }
    


    .row-context{
        white-space: nowrap;
        overflow-x: hidden;
        max-width:12rem;
        min-width:8rem;
        text-overflow: ellipsis;
        /* border:1px solid black; */
    }
/* Datatable base */
.table-content {
    overflow-x: auto;
}

#myTable {
    width: 100%;
    border-collapse: collapse;
    font-family: var(--font-family, Arial, Helvetica, sans-serif);
    font-size: 14px;
    color: var(--text-color, #222);
}

#myTable thead th {
    text-align: left;
    padding: 10px 12px;
    background: var(--table-header-bg, #f7f8fa);
    color: var(--table-header-color, #111);
    border-bottom: 1px solid rgba(0,0,0,0.08);
    position: sticky;
    top: 0;
    z-index: 2;
}



#myTable tbody td {
    padding: 10px 12px;
    border-bottom: 1px solid rgba(0,0,0,0.04);
    vertical-align: middle;
}

/* Row hover and stripe */
#myTable tbody tr:nth-child(odd) {
    background: var(--table-row-odd, #fff);
}
#myTable tbody tr:nth-child(even) {
    background: var(--table-row-even, #fbfbfb);
}
#myTable tbody tr:hover {
    background: rgba(0,0,0,0.03);
}

/* Small utilities */
/* .table-header {
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 8px;
} */

.table-header {
    display: flex;
    justify-content: space-between;
}
.table-title {
    font-family:var(--page-header-font);
    color: var(--page-header);
    font-size:1.2rem;
}

.page-count{
    color: var(--page-header);
    /* font-family:var(--page-header-font); */
    font-family: var(--heading-font-regular);
    font-size: 1rem;
}

.total{
    color:var(--placeholder);
}

.delete-all{
    padding-top:0.35rem;
}


.table-actions {
    margin-top:0.5rem;
    display: flex;

}
.table-actions input[type="text"] {
    height: 36px;
    padding: 6px 10px;
    border: 1px solid rgba(0,0,0,0.08);
    border-radius: 6px;
    min-width: 180px;
}
.table-actions .search-btn {
    font-size:0.9rem;
    border-radius: 6px;
    border:0px;
    border-radius: 100px;
    background: var(--icon-blue);
    margin-right:0.5rem;
    color: var(--enterprise-button);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:0.5rem 0.6rem;
}

.table-icon{
    
    height:1.2rem;
}

.search-btn{
    height:2.2rem;
    width: 2.2rem;
    background-color: var(--page-header)!important;
}
/* .table-actions .search-btn:active {
    transform: translateY(1px);
} */

/* DataTables wrapper compat (pagination, info, filters) */
.dataTables_wrapper .dataTables_paginate a,
.dataTables_wrapper .dataTables_paginate span {
    display: inline-block;
    padding: 6px 10px;
    margin: 0 4px;
    border-radius: 4px;
    background: transparent;
    color: var(--primary-color, #007bff);
    cursor: pointer;
}
.dataTables_wrapper .dataTables_paginate .current {
    background: var(--primary-color, #007bff);
    color: #fff;
}

/* Modern paginate buttons */
.dataTables_wrapper .dataTables_paginate .paginate_button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 36px;
    height: 36px;
    padding: 0 10px;
    margin: 0 6px;
    border-radius: 8px;
    border: 1px solid rgba(0,0,0,0.06);
    background: #fff;
    color: var(--primary-color, #007bff);
    box-shadow: 0 1px 0 rgba(0,0,0,0.02);
    transition: background .12s, transform .08s, color .12s;
}
.dataTables_wrapper .dataTables_paginate .paginate_button.current {
    background: var(--primary-color, #007bff);
    color: #fff;
    border-color: var(--primary-color, #007bff);
}
.dataTables_wrapper .dataTables_paginate .paginate_button:not(.current):hover:not(.disabled) {
    background: rgba(0,123,255,0.06);
    transform: translateY(-1px);
}
.dataTables_wrapper .dataTables_paginate .paginate_button.disabled {
    opacity: 0.5;
    cursor: default;
    transform: none;
}

/* Add subtle arrow affordances while keeping text visible */
.dataTables_wrapper .dataTables_paginate .previous::before {
    content: "◀ ";
    opacity: 0.85;
}
.dataTables_wrapper .dataTables_paginate .next::after {
    content: " ▶";
    opacity: 0.85;
}

/* hide default DataTables pagination since we use custom pager */
.dataTables_wrapper .dataTables_paginate {
    display: none !important;
}

.custom-pagination {
    display: flex;
    gap: 6px;
    align-items: center;
    margin-top: 12px;
}
.pager-btn {
    min-width: 36px;
    height: 36px;
    padding: 0 10px;
    border-radius: 8px;
    border:0px;
    background: transparent;
    color: var(--page-header)!important;
    cursor: pointer;
    font-size:0.8rem;
    text-transform:uppercase;
    font-family: var(--heading-font-regular);
}
.pager-btn.current {
    background: var(--primary, var(--primary-color, #007bff));
    color: #fff;
    border-color: var(--primary, var(--primary-color, #007bff));
}
.pager-btn:disabled {
    opacity: 0.5;
    cursor: default;
    color:var(--placeholder)!important;
}



/* Responsive: shrink padding on very small screens */
@media (max-width: 520px) {
    #myTable thead th,
    #myTable tbody td {
        padding: 8px 6px;
        font-size: 13px;
    }
}
</style>

/* Global rules -- must be non-scoped so they apply to DataTables-injected elements */
<style>
/* Hide default DataTables pagination wrapper (we use custom pagination) */
.dataTables_wrapper .dataTables_paginate {
    display: none !important;
}
</style>